import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
import { useTranslation } from 'hooks';
import { translations } from './translations';
import {
  PaginatePermissionsState,
  PaginatePermissionsActions,
} from 'store/ducks/settings/permissions';

import { PermissionFilterActions, SelectedFilterState } from 'store/ducks/filter';

import * as S from './styles';
import { MainContainer, Paginator, MenuSelector } from 'components/shared';
import { GridPermissions, FilterPermissions } from 'components/settings';

export const ListPermissions: React.FC = () => {
  const dispatch = useDispatch();
  const { getTranslation } = useTranslation(translations);

  const { loading, pagination, data } = useSelector<
    RootStateOrAny,
    PaginatePermissionsState
  >((state) => state.paginatePermissions);

  const { data: dataFilter } = useSelector<RootStateOrAny>(
    (state) => state.permissionFilter
  ) as SelectedFilterState;

  const handleSubmitFilter = useCallback(
    (value) => {
      const data = {
        ...dataFilter,
        ...value,
        page: 1,
      };
      dispatch(PermissionFilterActions.success(data));
    },
    [dispatch, dataFilter]
  );

  const handlePageChange = useCallback(
    (value) => {
      const data = {
        ...dataFilter,
        page: value,
      };
      dispatch(PermissionFilterActions.success(data));
    },
    [dispatch, dataFilter]
  );

  const getData = useCallback(() => {
    dispatch(PaginatePermissionsActions.request({ ...dataFilter }));
  }, [dispatch, dataFilter]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation('configuracoes')} <MenuSelector page="permissions" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          <FilterPermissions onFilter={handleSubmitFilter} filters={dataFilter} />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridPermissions permissions={data} loading={loading} />
        <Paginator
          pagination={pagination}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
